<div class="group" *ngFor="let group of groupedPositions">
  <div
    class="p-2 m-1 cursor-pointer d-inline-block"
    [class.collapsed]="!group.market.expanded"
    (click)="collapsable && group.market.expanded = !group.market.expanded"
  >
    <img class="me-2" [src]="group.market.icon" />
    {{ group.market.name }} Market ({{ group.positions.length }})
    <img class="expand-icon" src="/retired-arbitrum/assets/images/icons/expand_20.svg" *ngIf="collapsable" />
  </div>
  <div class="collapse border-top" [(ngbCollapse)]="!group.market.expanded">
    <div class="table-responsive">
      <table class="table table-nowrap table-no-bottom-border mb-0">
        <!-- <colgroup appColEvenly [cols]="cols"></colgroup> -->
        <colgroup *ngIf="!isOpenInterest && !settled">
          <col width="60px"/>
          <col width="164px"/>
          <col width="100px"/>
          <col width="20%"/>
          <col width="20%"/>
          <col width="20%"/>
          <col width="20%"/>
          <col width="72px"/>
        </colgroup>
        <thead>
          <tr>
            <th>Side</th>
            <th class="text-end">Positions</th>
            <ng-container *ngIf="!settled">
              <th class="text-end" *ngIf="!isOpenInterest">Avg. Price</th>
              <th class="text-end">Size</th>
              <ng-container *ngIf="!isOpenInterest">
                <th class="text-end">Premium</th>
                <th class="text-end">Equity</th>
                <th class="text-end">uPnL</th>
                <th class="text-end" *ngIf="closable">Action</th>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="settled">
              <th class="text-end">PnL</th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="group.positions.length">
            <tr *ngFor="let position of group.positions">
              <td class="align-middle" [class.text-warning]="position.subsidyVoucherAmount?.gt(0)">
                {{ position.size.gte(0) ? 'Buy' : 'Sell' }}
                <img class="voucher ms-1" src="/retired-arbitrum/assets/images/compensation/shield-money_20.svg" *ngIf="position.subsidyVoucherAmount?.gt(0)"/>
              </td>
              <td class="align-middle text-end">
                <div class="text-white">
                  $<ngx-money
                    [value]="position.strike"
                    [precision]="0"
                    [disableTooltip]="true"
                  ></ngx-money
                  >-{{ position.isCall ? 'Call' : 'Put' }}
                </div>
                <div class="fs-7">{{ position.expiry * 1000 | date : 'MMM dd y' }}</div>
              </td>
              <ng-container *ngIf="!settled">
                <td class="align-middle text-end" *ngIf="!isOpenInterest">
                  $<ngx-money [value]="position.avg" [precision]="2"></ngx-money>
                </td>
                <td class="align-middle text-end">
                  <ngx-money [value]="position.size.abs()" [precision]="2"></ngx-money>
                </td>
                <ng-container *ngIf="!isOpenInterest">
                  <td class="align-middle text-end">
                    <ngx-money
                      [class.text-success]="position.notional.gt(0)"
                      [class.text-danger]="position.notional.lt(0)"
                      [value]="position.notional"
                      [precision]="2"
                      [signed]="true"
                      symbol="$"
                    ></ngx-money>
                  </td>
                  <td class="align-middle text-end" *appLet="position.value | async; let value">
                    <div *ngIf="value">
                      <ngx-money
                        [class.text-success]="value.gt(0)"
                        [class.text-danger]="value.lt(0)"
                        [value]="value"
                        [precision]="2"
                        [signed]="true"
                        symbol="$"
                      ></ngx-money>
                    </div>
                  </td>
                  <td class="align-middle text-end" *appLet="position.upnl | async; let upnl">
                    <div *ngIf="upnl">
                      <ngx-money
                        [class.text-success]="upnl.gt(0)"
                        [class.text-danger]="upnl.lt(0)"
                        [value]="upnl"
                        [precision]="2"
                        [signed]="true"
                        symbol="$"
                      ></ngx-money>
                    </div>
                  </td>
                  <td class="align-middle text-end" *ngIf="closable">
                    <a class="btn btn-small cursor-pointer" (click)="onClose(group.market, position)">Close</a>
                  </td>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="settled">
                <td class="align-middle text-end">
                  <ngx-money
                    [class.text-success]="position.realized.gt(0)"
                    [class.text-danger]="position.realized.lt(0)"
                    [value]="position.realized"
                    [precision]="2"
                    [signed]="true"
                    symbol="$"
                  ></ngx-money>
                </td>
              </ng-container>
            </tr>
          </ng-container>
          <tr *ngIf="!group.positions.length">
            <td [attr.colspan]="cols" class="text-center">You have no open positions.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
